/*!
 * @package jquery.shiptime
 * @version 0.1.3
 * @copyright (C) 2014 Dane Grant (danecando@gmail.com)
 * @license MIT
 */
(function ($) {
  var defaults = {
    // UTC timezone offset for your stores location
    timezone: "-0500",

    // Enter your shipping cutoff deadline in 24 hour format
    deadline: {
      hour: 11,
      minute: 0,
    },

    // Name of estimated shipping method
    shipMethodName: "Fixed Rate Shipping",

    // This is to make sure we only show transit info if an item is in stock!
    stockSelector: ".product-view.stock > span", // selector for element that notifies stock status
    inStockText: "In stock", // in stock text

    // Add dates that we will be excluding from shipping and delivery (comma separated)
    noShipping: "1/1, 7/4, 12/25, 12/31",
  };

  function ShippingTime(element, options) {
    this.element = element;
    this.options = $.extend({}, defaults, options);

    try {
      if (moment === undefined || $ === undefined)
        throw Error("please include jquery & moment.js");
    } catch (e) {
      console.log(e);
    }

    // Display shipping deadline info
    this.displayShipTime();
  }

  ShippingTime.prototype.isWeekday = function (moment) {
    return moment.day() !== 0 && moment.day() !== 6 ? true : false;
  };

  ShippingTime.prototype.isExcluded = function (moment) {
    var dates = this.options.noShipping.split(",");
    for (var i = 0; i < dates.length; i++) {
      if (moment.zone("-0500").format("M/D") == dates[i]) {
        return true;
      }
    }
    return false;
  };

  ShippingTime.prototype.shipDay = function (deadline) {
    return moment().zone(this.options.timezone).isSame(deadline, "d")
      ? "Today"
      : deadline.format("dddd");
  };

  ShippingTime.prototype.shippingDeadline = function (hour, minute) {
    var deadline = moment()
      .zone(this.options.timezone)
      .hour(hour)
      .minute(minute)
      .second(0);
    while (this.isExcluded(deadline)) {
      deadline.add("h", 24);
    }
    if (
      moment().zone(this.options.timezone).hour() >= deadline.hour() &&
      this.isWeekday(moment().zone(this.options.timezone))
    ) {
      deadline.add("h", 24);
    }
    if (!this.isWeekday(deadline)) {
      return deadline.day() === 0
        ? deadline.add("h", 24)
        : deadline.add("h", 48);
    } else {
      return deadline;
    }
  };

  ShippingTime.prototype.timeUntilDeadline = function (deadline) {
    var minutesTill = Math.abs(
      moment().zone(this.options.timezone).diff(deadline, "m")
    );
    for (var hoursTill = 0; minutesTill >= 60; hoursTill++) {
      minutesTill -= 60;
    }
    return {
      hours: hoursTill,
      minutes: minutesTill,
    };
  };

  ShippingTime.prototype.displayShipTime = function () {
    var plugin = this;

    if (
      $(this.options.stockSelector).text() == this.options.inStockText ||
      this.options.inStockText === true
    ) {
      var deadline = this.shippingDeadline(
        this.options.deadline.hour,
        this.options.deadline.minute
      );
      var timeLeft = this.timeUntilDeadline(deadline);

      $(this.element).append(
        '<span class="order">Order</span> within <span class="time-left">' +
          timeLeft.hours +
          " hrs " +
          timeLeft.minutes +
          ' mins</span> to ship <span class="ship-day">' +
          this.shipDay(deadline) +
          "</span>"
      );
    }
  };

  $.fn.shipTime = function (options) {
    return this.each(function () {
      new ShippingTime(this, options);
    });
  };
})(jQuery);
